// @ts-nocheck
import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import rootReducer from './reducers';

const persistConfig = {
	key: 'root',
	version: 1,
	storage,
	whitelist: [
		'organization',
		'otpAuth',
		'restaurant',
		'chats',
		'currentUser',
		'supplierCatalog',
		'order',
		'cart',
		'team',
		'marketplace',
		'general',
	],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

function configureAppStore(preloadedState) {
	const store = configureStore({
		reducer: persistedReducer,
		preloadedState,
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware({
				serializableCheck: false,
			}),
	});

	if (process.env.NODE_ENV !== 'production' && module.hot) {
		module.hot.accept('./reducers', () => store.replaceReducer(rootReducer));
	}

	return store;
}

export const store = configureAppStore({});
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
